import React from 'react';
import { StyleSheet } from 'react-native';
import RowView from '../RowView';
import { CommonStyles } from '../../styles';

const ListControl = ({ items, renderItem, noShadow, style, ...rest }) => {
  return (
    <RowView style={[styles.container, noShadow ? null : CommonStyles.shadow, style]} {...rest}>
      {items && items.map(renderItem)}
    </RowView>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: 'white',
    overflow: 'hidden',
  },
});

export default ListControl;
